import { render, staticRenderFns } from "./NewsDetail3.vue?vue&type=template&id=2eb263e5&scoped=true&"
import script from "./NewsDetail3.vue?vue&type=script&lang=js&"
export * from "./NewsDetail3.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail3.vue?vue&type=style&index=0&id=2eb263e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb263e5",
  null
  
)

export default component.exports